<template>
  <div :class="['card', merchant ? 'clean' : 'hike']">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    merchant: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  background-color: #fff;
  color: #3e3e3e;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  box-shadow: 0 20px 40px rgb(62 62 62 / 10%);
  border-radius: 15px;
  padding: 2rem 3.5rem 3.5rem;
  position: relative;
  z-index: 0;
  display: flex;
  width: 100%;
  max-width: 900px;
  flex-direction: column;
  align-items: center;

  &:after {
    z-index: -1;
    height: 65%;
    background: #fff;
    background: linear-gradient(0deg, #fff, hsla(0, 0%, 100%, 0));
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 100%;
  }

  &.hike {
    &:before {
      z-index: -2;
      height: 50%;
      background: url('/images/registration/triangles.svg');
      background-position: 5px 10px;
      background-repeat: repeat-x;
      background-size: 900px;
      opacity: .5;
      position: absolute;
      content: "";
      top: 0;
      left: 0;
      width: 100%;
    }
  }
}
@media only screen and (max-width: 999px) {
  .card {
    width: 90vw;
    flex-direction: column;

    .form-container {
      flex-direction: column;
    }
  }
}
@media only screen and (max-width: 519px) {
  .card {
    padding: 2rem;
  }
}
</style>
